import axios from "axios";
import router from "@/router";
import store from '@/store';

import { ElMessage, ElMessageBox, ElNotification } from 'element-plus'

import {
  getAccessToken,
  getRefreshToken,
  removeToken,
  setAccessToken
} from '@/utils/auth'

// import mixin from "@/mixins/mixin";
// import {  RouterName } from "@/enums";
// const { changeIndex, routerManager } = mixin();

const BASE_URL = process.env.NODE_HOST;

axios.defaults.timeout = 5000; // 超时时间设置
axios.defaults.withCredentials = true; // true允许跨域
axios.defaults.baseURL = BASE_URL;
// Content-Type 响应头
axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";

// 是否显示重新登录
export const isRelogin = { show: false }
// Axios 无感知刷新令牌，参考 https://www.dashingdog.cn/article/11 与 https://segmentfault.com/a/1190000020210980 实现
// 请求队列
let requestList: any[] = []
// 是否正在刷新中
let isRefreshToken = false
// 请求白名单，无须 token 的接口

//请求拦截器 sgh add
axios.interceptors.request.use(config => {
  // 在发送请求之前做些什么，例如添加token等公共参数
  // config.headers['Authorization'] = 'Bearer YOUR_TOKEN_HERE'; // 例如添加token
  config.headers['Authorization'] = `Bearer ${getAccessToken()}`; // 添加token
  // config.headers['Authorization'] = `Bearer ${store.getters.accessToken}`; // 添加token
  console.log(getAccessToken());
  // console.log(store.getters.accessToken);
  return config;
}, error => {
  // 对请求错误做些什么
  return Promise.reject(error);
});
// 响应拦截器
axios.interceptors.response.use(
  async (response) => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    // const code = response.status
    const code = response.data.code || response.status
    const config = response.config
    const msg = response.data.msg
    if (code === 401) {
      // 如果未认证，并且未进行刷新令牌，说明可能是访问令牌过期了
      if (!isRefreshToken) {
        isRefreshToken = true
        // 1. 如果获取不到刷新令牌，则只能执行登出操作
        if (!getRefreshToken()) {
          return handleAuthorized()
        }
        // 2. 进行刷新访问令牌
        try {
          const refreshTokenRes = await refreshToken()
          // 2.1 刷新成功，则回放队列的请求 + 当前请求
          setAccessToken((await refreshTokenRes).data.data)
          config.headers!.Authorization = 'Bearer ' + getAccessToken()
          requestList.forEach((cb: any) => {
            cb()
          })
          requestList = []
          if ((config!.headers || {}).isEncrypt){
            (config!.headers || {}).isEncrypted = true
          }
          return axios(config)
        } catch (e) {
          // 为什么需要 catch 异常呢？刷新失败时，请求因为 Promise.reject 触发异常。
          // 2.2 刷新失败，只回放队列的请求
          requestList.forEach((cb: any) => {
            cb()
          })
          // 提示是否要登出。即不回放当前请求！不然会形成递归
          return handleAuthorized()
        } finally {
          requestList = []
          isRefreshToken = false
        }
      } else {
        // 添加到队列，等待刷新获取到新的令牌
        return new Promise((resolve) => {
          requestList.push(() => {
            config.headers!.Authorization = 'Bearer ' + getAccessToken() // 让每个请求携带自定义token 请根据实际情况自行修改
            resolve(axios(config))
          })
        })
      }
    }else if (code !== 200) {
      if (msg === '无效的刷新令牌') {
        // hard coding：忽略这个提示，直接登出
        console.log(msg)
        return handleAuthorized()
      } else {
        ElNotification.error({ title: msg })
      }
      return Promise.reject('error')
    }else {
      return Promise.resolve(response);
    }
  },
  // 服务器状态码不是2开头的的情况
  (error) => {
    if (error.response && error.response.status) {
      switch (error.response.status) {
        // 401: 未登录
        case 401:
          router.replace({
            path: "/",
            query: {
              // redirect: router.currentRoute.fullPath
            },
          });
          break;
        case 403:
          // console.log('管理员权限已修改请重新登录')
          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          setTimeout(() => {
            router.replace({
              path: "/",
              query: {
                // redirect: router.currentRoute.fullPath
              },
            });
          }, 1000);
          break;

        // 404请求不存在
        case 404:
          // console.log('请求页面飞到火星去了')
          break;
      }
      return Promise.reject(error.response);
    }
  }
);

export function getBaseURL() {
  return BASE_URL;
}

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get(url, params?: object) {
  return new Promise((resolve, reject) => {
    axios.get(url, params).then(
      (response) => resolve(response.data),
      (error) => reject(error)
    );
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data).then(
      (response) => resolve(response.data),
      (error) => reject(error)
    );
  });
}

/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function deletes(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.delete(url, data).then(
      (response) => resolve(response.data),
      (error) => reject(error)
    );
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(
      (response) => resolve(response.data),
      (error) => reject(error)
    );
  });
}

// const getRefreshToken = () => {
//   return store.getters.refreshToken
// }

// const getAccessToken = () => {
//   return store.getters.accessToken
// }

const refreshToken = async () => {
  // axios.defaults.headers.common['tenant-id'] = getTenantId()
  return await axios.post(BASE_URL + '/auth/refresh-token?refreshToken=' + getRefreshToken())
}

const handleAuthorized = () => {
  // const { t } = useI18n()
  if (!isRelogin.show) {
    // 如果已经到登录页面则不进行弹窗提示
    if (window.location.href.includes('login')) {
      return
    }
    isRelogin.show = true
    ElMessageBox.confirm('登录超时,请重新登录!', '系统提示', {
      showCancelButton: false,
      closeOnClickModal: false,
      showClose: false,
      closeOnPressEscape: false,
      confirmButtonText: '重新登录',
      type: 'warning'
    }).then(() => {
      // resetRouter() // 重置静态路由表
      // deleteUserCache() // 删除用户缓存
      removeToken()
      isRelogin.show = false
      // 干掉token后再走一次路由让它过router.beforeEach的校验
      const hh=window.location.href
      window.location.href = hh
      // routerManager(RouterName.Login, { path: RouterName.Login });
      // router.push({ path: '/' });
    })
  }
  return Promise.reject('登录超时,请重新登录!')
}

// const removeToken = () => {
//   store.commit("setAccessToken", "");
//   store.commit("setRefreshToken", "");
// }

// const setToken = (token) => {
//   store.commit("setAccessToken", token.accessToken);
//   store.commit("setRefreshToken", token.refreshToken);
// }